// extracted by mini-css-extract-plugin
export var calltoAction = "Contact-module--calltoAction--f1e03";
export var error = "Contact-module--error--b1d39";
export var field = "Contact-module--field--47043";
export var form = "Contact-module--form--ee277";
export var loader = "Contact-module--loader--bf6c6";
export var message = "Contact-module--message--1c2d6";
export var msgError = "Contact-module--msgError--bf76c";
export var spin = "Contact-module--spin--6f060";
export var submit = "Contact-module--submit--1fd14";
export var success = "Contact-module--success--1b0a0";
export var title = "Contact-module--title--3239d";
export var welcome = "Contact-module--welcome--d13fd";